export default {"inputWrapper":"q4cGp","floatingLabel":"uV9Kk","focused":"cs7bu","text-input":"Z-eSM"};